import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetCurrentCustomerCreditInformationParameter } from "@store/Services/CreditInformationService";
import { CreditInformationsState } from "@store/Store/Data/CreditInformations/CreditInformationsState";
import { CreditInformationModel } from "@store/Types/CreditInformation";
import { Draft } from "immer";

const initialState: CreditInformationsState = {
    isLoading: false,
};

const reducer = {
    "Store/Data/CreditInformations/BeginLoadCreditInformations": (
        draft: Draft<CreditInformationsState>,
        action: { parameter: GetCurrentCustomerCreditInformationParameter },
    ) => {
        draft.isLoading = true;
    },
    "Store/Data/CreditInformations/CompleteLoadCreditInformations": (
        draft: Draft<CreditInformationsState>,
        action: {
            parameter: GetCurrentCustomerCreditInformationParameter;
            creditInformationModel: CreditInformationModel;
        },
    ) => {
        draft.isLoading = false;
        draft.creditInformationModel = action.creditInformationModel;
    },
};

const creditInformationsReducer = createTypedReducerWithImmer(initialState, reducer);
export default creditInformationsReducer;
